
import React from 'react';
import { useLanguage } from "@/contexts/LanguageContext";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Location } from "@/components/campaign/types";

interface WakiWarningProps {
  selectedLocations: Location[];
}

const WakiWarning: React.FC<WakiWarningProps> = ({ selectedLocations }) => {
  const { language, t } = useLanguage();
  
  // Check if any Waki location is selected
  const hasWakiLocation = selectedLocations.some(
    location => location.mediaOwner === 'Waki'
  );
  
  if (!hasWakiLocation) return null;
  
  return (
    <Alert className="bg-amber-50 border-amber-200 text-amber-800">
      <AlertDescription>
        {language === 'ar' 
          ? t('wakiReviewWarning')
          : 'Waki needs a 5-day period to review the Ad material before Publishing.'}
      </AlertDescription>
    </Alert>
  );
};

export default WakiWarning;
